export default "__VITE_ASSET__CNNNXL5i__"